import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DeviceService } from 'src/app/services/devices/device.service';
import {
  isAncPlusDevice,
  isAstroLumDevice,
  isDatalogPlusDevice,
} from 'src/app/services/devices/device-type.util';
import { TranslateModule } from '@ngx-translate/core';
import { HistoryAncPlusComponent } from './history-anc-plus/history-anc-plus.component';
import { HistoryAstrolumComponent } from './history-astrolum/history-astrolum.component';
import { HistoryAnalyticsDateFilterComponent, HistoryAnalyticsDateRange } from './history-analytics-date-filter/history-analytics-date-filter.component';

@Component({
  selector: 'app-history-analytics',
  imports: [
    CommonModule,
    TranslateModule,
    HistoryAncPlusComponent,
    HistoryAstrolumComponent,
    HistoryAnalyticsDateFilterComponent,
  ],
  templateUrl: './history-analytics.component.html',
  styleUrl: './history-analytics.component.scss',
})
export class HistoryAnalyticsComponent implements OnInit {

  serial = '';
  deviceInfo: any = null;
  loadingDevice = true;
  dateRange: HistoryAnalyticsDateRange | null = null;

  constructor(
    public _aRoute: ActivatedRoute,
    private _device: DeviceService,
  ) {}

  ngOnInit(): void {
    this._aRoute.parent?.params.subscribe((params: Params) => {
      this.serial = params['serial'];
      this.loadDeviceInfo();
    });
  }

  private loadDeviceInfo(): void {
    if (!this.serial) {
      this.loadingDevice = false;
      return;
    }

    this.loadingDevice = true;
    const cached = this._device.getActiveDeviceInfo();
    if (cached?.serial === this.serial) {
      this.deviceInfo = cached;
      this.loadingDevice = false;
      return;
    }

    this._device.getDeviceInfo(this.serial).subscribe({
      next: (data) => {
        this.deviceInfo = data;
        this.loadingDevice = false;
      },
      error: () => {
        this.deviceInfo = null;
        this.loadingDevice = false;
      },
    });
  }

  onRangeChange(range: HistoryAnalyticsDateRange): void {
    this.dateRange = range;
  }

  get showAstrolumHistory(): boolean {
    return isAstroLumDevice({ ...this.deviceInfo, serial: this.serial });
  }

  get showAncPlusHistory(): boolean {
    return isAncPlusDevice({ ...this.deviceInfo, serial: this.serial })
      || isDatalogPlusDevice({ ...this.deviceInfo, serial: this.serial });
  }

  get showUnsupportedMessage(): boolean {
    return !this.loadingDevice && !this.showAstrolumHistory && !this.showAncPlusHistory;
  }

  /** ANC+/Datalog+ o Astrolum: mismo shell de filtros encima del hijo activo. */
  get showDeviceHistoryView(): boolean {
    return !this.loadingDevice && (this.showAncPlusHistory || this.showAstrolumHistory);
  }

  /** Asegura serial en el objeto para utilidades que detectan tipo por prefijo. */
  get deviceInfoForChild(): Record<string, unknown> | null {
    if (!this.deviceInfo) {
      return this.serial ? { serial: this.serial } : null;
    }
    return { ...this.deviceInfo, serial: this.serial || this.deviceInfo.serial };
  }
}
